export enum RightType {
  RIGHT_CONSULT_ALL_AGENDAS_AND_FOLDERS = 'RCAF',
  RIGHT_ASSIGN_APPOINTMENT_TO_COLLABORATOR = 'RAAC',
  RIGHT_UPDATE_RECORD = 'RUR',
  RIGHT_ADD_NEW_RECORD = 'RANR'
}

export enum RightTypeLabel {
  RCAF = 'Consulter tous les agendas et tous les dossiers',
  RAAC = 'Assigner un rendez-vous à un collaborateur',
  RUR = 'Modifier la fiche d’un bien',
  RANR = 'Ajouter un nouveau bien immobilier'
}

export enum TeamMemberFormType {
  CREATE,
  UPDATE
}
